// extracted by mini-css-extract-plugin
export default {"wrapper":"ChatEvents_wrapper__Ey0Kb","noEventsToShow":"ChatEvents_noEventsToShow__hxZty"};